import { PolicyApply } from '../interfaces/policy-apply.interface';

/** Stub: MinimumRentalPolicy apply. */
export const MinimumRentalPolicy: PolicyApply<
	unknown,
	unknown,
	Record<string, unknown>
> = {
	apply(
		_input: unknown,
		_config: Record<string, unknown> | null | undefined,
	): unknown {
		return null;
	},
};
